import { useRef, useEffect } from "react";

type YearListProps = {
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
};

export const YearList: React.FC<YearListProps> = ({
  currentDate,
  setCurrentDate,
}) => {
  const currentYearRef = useRef<HTMLButtonElement>(null);

  // Scroll to current month/year when component mounts
  useEffect(() => {
    if (currentYearRef.current) {
      currentYearRef.current.scrollIntoView({ block: "center" });
    }
  }, []);

  // Generate years for selection (current year -125 and +15 years)
  const generateYears = () => {
    const currentYear = new Date().getUTCFullYear();
    const years = [];
    for (let i = currentYear - 125; i <= currentYear + 15; i++) {
      years.push(i);
    }
    return years;
  };

  const years = generateYears();

  const handleSelectYear = (year: number) => {
    setCurrentDate(
      new Date(
        Date.UTC(
          year,
          currentDate.getUTCMonth(),
          1,
          currentDate.getUTCHours(),
          currentDate.getUTCMinutes()
        )
      )
    );
  };

  return (
    <div className="border-l pl-4 outline-quaternary">
      <div className="h-full flex flex-col w-max custom-scrollbar overflow-y-auto pr-3 mr-1">
        {years.map((year) => (
          <button
            key={year}
            ref={currentDate.getUTCFullYear() === year ? currentYearRef : null}
            onClick={() => handleSelectYear(year)}
            className={`w-full p-2 text-left rounded-lg
              ${
                currentDate.getUTCFullYear() === year
                  ? "cta-primary font-light-primary body-2-medium"
                  : "body-2-regular font-secondary hover:surface-secondary"
              }
            `}
          >
            {year}
          </button>
        ))}
      </div>
    </div>
  );
};
